const labelPrefix = 'bloc_business';

/**
 * @description Build the label for the analytics.
 * @param {object} labelConf - Element that will use to build the label.
 * @param {string} labelConf.label - String the label part that will be used for the analytics label.
 * @param {string} labelConf.value - String the value part that will be used for the analytics label.
 * @param {string} [labelConf.prefix=labelPrefix] - String the prefix part that will be used for the analytics label.
 * @returns {string} The label construct with 'prefix::label::value'.
 */
export const analyticsLabelBuilder = ({label, value, prefix = labelPrefix}) => `${prefix}::${label}::${value}`;
